module.exports = __webpack_public_path__ + "img/image_002.7b83d274.jpeg";